import { apiClient, ApiName } from '@shared/services/api'

export const fetchFinancialInstitutions = () => {
  return apiClient.get(ApiName.ADMINS, 'financialInstitutions')
}

export const fetchFinancialInstitution = (institution, clientId) => {
  return apiClient.get(
    ApiName.ADMINS,
    `financialInstitutions/${institution}/internationalBanks?clientId=${clientId}`
  )
}

export const putUpdateBroker = (id, data) => {
  return apiClient.put(ApiName.ADMINS, `financialInstitutions/${id}`, data)
}
